import findLast from 'array.prototype.findlast';

if (typeof Array.prototype.findLast !== 'function') {
  findLast.shim();
}
